"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ftc(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.4522 4.50012C18.4522 4.50012 19.6874 5.59812 18.8107 7.83237C18.644 8.24308 18.4126 8.62442 18.1252 8.96187L15.0764 12.5394L12.6299 15.7329C12.6299 15.7329 9.82044 15.2709 8.72844 16.4041L13.3589 16.6096C13.3589 16.6096 12.3704 17.6919 8.46894 16.9171C8.46894 16.9171 8.52144 18.0031 10.2907 18.3121C10.2907 18.3121 8.72844 18.8289 7.79169 17.3319C7.79169 17.3319 7.79169 18.4179 8.88369 18.8799C8.88369 18.8799 7.99869 19.0854 7.26969 18.1576L6.02244 19.4956C6.02244 19.4956 5.76369 19.5474 5.91894 19.2909L6.95919 18.0549C6.95919 18.0549 7.06269 17.1781 6.43719 17.4864C6.43719 17.4864 6.02244 17.6401 6.17769 18.1059C6.17769 18.1059 5.55219 17.5929 6.28194 16.9216L4.87494 15.5281L6.69594 16.5069L5.91519 14.5996L7.21419 16.2504C7.21419 16.2504 7.10619 14.3949 7.68069 13.8811C7.68069 13.8811 7.83594 15.6856 8.56569 15.8401L8.51319 12.0766L9.29469 11.4061L9.39819 13.7746C9.39819 13.7746 9.60519 14.0311 9.81219 13.7236C9.81219 13.7236 10.2824 12.9496 10.2824 10.6831L11.5297 9.49812L11.6857 10.4266C11.6857 10.4266 11.8964 10.7859 12.1559 10.4776L12.4147 8.67387C12.4147 8.67387 14.0797 6.76662 18.4522 4.50012ZM10.1272 14.9626C14.4427 10.9951 16.7347 7.12962 16.7302 7.12962C14.5987 8.62212 10.1272 14.9634 10.1272 14.9634V14.9626Z", fill: color }));
}
exports["default"] = ftc;
//# sourceMappingURL=ftc.js.map